// extracted by mini-css-extract-plugin
export default {"section":"ParallaxSection_section__mNF8I"};